module.exports = __webpack_public_path__ + "img/refresh.76cfe583.svg";